import { render, staticRenderFns } from "./StudentPasswordReminderComplete.vue?vue&type=template&id=776eca0a&scoped=true&lang=pug&"
import script from "./StudentPasswordReminderComplete.vue?vue&type=script&lang=ts&"
export * from "./StudentPasswordReminderComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776eca0a",
  null
  
)

export default component.exports